module.exports = __webpack_public_path__ + "static/media/dotBlue.c0dcfea0.svg";